module.exports = __webpack_public_path__ + "static/img/Steele_Sidebottom_desktop.7d34653.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Steele_Sidebottom_desktop.jpg
// module id = D89i
// module chunks = 0